module.exports = __webpack_public_path__ + "img/2-5.983ea7f7.svg";